import { styled } from 'styled-components';
import { border, space } from 'styled-system';
import { FONT_BRIGHTNESS } from '@design-system/theme';
export const Divider = styled.hr.withConfig({
    shouldForwardProp: (prop) => !['borderBottomColor', 'borderBottomWidth', 'borderBottomStyle'].includes(prop),
}) `
  width: ${({ width = '100%' }) => width};
  border: none;
  border-bottom-width: ${({ borderBottomWidth = '1px' }) => borderBottomWidth};
  border-bottom-style: ${({ borderBottomStyle = 'solid' }) => borderBottomStyle};
  border-bottom-color: ${({ borderBottomColor, theme }) => {
    if (borderBottomColor) {
        return borderBottomColor;
    }
    if (theme.themeVariables.fontBrightness === FONT_BRIGHTNESS.LIGHT) {
        return theme.colors.snow;
    }
    return theme.colors.horizon;
}};

  // Keep this order
  ${space}
  ${border}
`;
//# sourceMappingURL=Divider.js.map